module.exports = __webpack_public_path__ + "img/banner2_3_en.0ddff6e1.png";